import ALaCarte from './ALaCarte';

export default ALaCarte;
